/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';

export const lazyComponentLoader = (loader: () => Promise<React.ComponentType<any>>) =>
    React.lazy(async () => ({ default: await loader() }));
